import styled from '@emotion/styled'

import ColumnTrack from '@segment/matcha/components/ColumnTrack'
import FeatureBoxBase, * as FeatureBox from '@segment/matcha/components/FeatureBox'
import { NamingConventionsIcon, IntegrationIcon, CompliantIcon } from '@segment/matcha/components/Icons/Brandbook'
import IconWrapper from '@segment/matcha/components/IconWrapper'

import CopyTextBase, * as CopyText from '@segment/matcha/recipes/CopyText'
import SectionBase, * as Section from '@segment/matcha/recipes/Section'

import LogoCarousel from '@segment/templates/LogoCarousel'

const copy = {
  heading: `A smarter way to collect data`,
  description: `Enable company-wide data standardization.`,
}

const features = [
  {
    heading: `Standardized`,
    description: `Power all tools with the same high-quality data.`,
    icon: <NamingConventionsIcon />,
  },
  {
    heading: `Compliant`,
    description: `Accelerate your data compliance with GDPR, CCPA, and other privacy regulations.`,
    icon: <CompliantIcon />,
  },
  {
    heading: `Integrated`,
    description: `Integrating a new tool is easy and takes minutes.`,
    icon: <IntegrationIcon />,
  },
]

export const CollectData = () => {
  return (
    <>
      <CarouselSectionBase variant="noCopy">
        <LogoCarousel />
      </CarouselSectionBase>
      <StyledSectionBase variant="centered">
        <Section.Copy>
          <CopyTextBase centered={true}>
            <CopyText.Heading tag="h2" variant="h2">
              {copy.heading}
            </CopyText.Heading>
            <CopyText.Description>{copy.description}</CopyText.Description>
          </CopyTextBase>
        </Section.Copy>
        <Section.Contents>
          <ColumnTrack columns={1} overrides={{ md: 3 }}>
            {features.map((feature) => (
              <StyledFeatureBoxBase key={feature.heading} headerPosition="top" alignment="left">
                <FeatureBox.Header>
                  <IconWrapper variant="circle" elevation={1}>
                    {feature.icon}
                  </IconWrapper>
                </FeatureBox.Header>
                <FeatureBox.Body>
                  <FeatureBox.Title>{feature.heading}</FeatureBox.Title>
                  <FeatureBox.Text>{feature.description}</FeatureBox.Text>
                </FeatureBox.Body>
              </StyledFeatureBoxBase>
            ))}
          </ColumnTrack>
        </Section.Contents>
      </StyledSectionBase>
    </>
  )
}

const CarouselSectionBase = styled(SectionBase)`
  ${Section.Wrapper} {
    ${({ theme }) => theme.breakpoints.up(`lg`)} {
      padding: 44px 80px;
    }
  }
`

const StyledSectionBase = styled(SectionBase)`
  max-width: 1280px;
`

const StyledFeatureBoxBase = styled(FeatureBoxBase)`
  padding: 16px;
  max-width: 289px;

  ${({ theme }) => theme.breakpoints.up(`md`)} {
    max-width: unset;
  }

  ${({ theme }) => theme.breakpoints.up(`lg`)} {
    padding: 24px;
  }
`

export default CollectData
